import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { swalMessages } from '@auteco/constants';
import swal from 'sweetalert';
import filterArray from '../../utils/filterArray'
import ManagerPage from '../../pages/PolygonsPage/ManagerPage/ManagerPage';
import { Context } from '../../context/Contex';
import { ScreenLoading2 } from '../../components/sharedComponents/ScreenLoading/index'
import polygonsService from '../../services/polygonsService'

const GerentesContainer = () => {
  const [manager, setManager] = useState('');
  const [managerBosses, setManagerBosses] = useState('');
  const [bosses, setBosses] = useState('');
  const [select, setSelect] = useState('')
  const [search, setSearch] = useState('')
  const [searchManager, setSearchManager] = useState('')

  const history = useHistory()
  const dataTable = []

  const { unidad, permisos } = useContext(Context);

  /*= =======================================================================
  Get manager
======================================================================== */
  const getManagers = () => {
    polygonsService.getManager(unidad)
      .then((response) => {
        setManager(response.data.data);
      })
      .catch((error) => {
        history.push('/login');
        console.log(error);
      });
  }

  /*= =======================================================================
  Get manager y Jejes
======================================================================== */
  const getManagerBosses = () => {
    polygonsService.getManagerBosses(unidad)
      .then((response) => {
        setManagerBosses(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /*= =======================================================================
  Get bosses
======================================================================== */
  const getBosses = () => {
    polygonsService.getJefes(unidad)
      .then((response) => {
        setBosses(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getManagerBosses()
    getManagers()
    getBosses()
  }, []);

  /*= =======================================================================
 Post manager
======================================================================== */
  const handleCreateManager = ({ value }) => {
    const body = {
      nombre: value,
      unidad_negocio_id: unidad,
    }
    polygonsService.postGerente(body)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.REPEAT_MESSAGE_ERROR)
        } else { getManagers() }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Editar Gerente
======================================================================== */
  const handleUpdate = params => {
    polygonsService.putManager(params)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED)
        } else {
          setSelect(params)
          getManagers()
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Eliminar manager
======================================================================== */
  const handleDelete = params => () => {
    const { id } = params
    swal(swalMessages.DELETE_CONFIRM)
      .then((willDelete) => {
        if (willDelete) {
          polygonsService.deleteGerente(id)
            .then((response) => {
              if (response.data.id === 0) {
                swal(swalMessages.DELETE_ERROR)
              } else { getManagers()}
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
  };

  /*= =======================================================================
Asignar manager a bosses
======================================================================== */
  const handleCreate = params => () => {
    polygonsService.postGerenteJefe(params)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED)
        } else { getManagerBosses() }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Eliminar manager y bosses
======================================================================== */
  const handleDeleteTableMagagers = ({ rowData }) => {
    swal(swalMessages.DELETE_CONFIRM)
      .then((willDelete) => {
        if (willDelete) {
          polygonsService.deleteGerenteTable(rowData)
            .then(() => {
              getManagerBosses()
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
  };

  const handleSelect = item => () => {
    setSelect(item)
  }

  const handleSearch = event => {
    setSearch(event.target.value)
  }

  const hadleSearchManager = event => {
    setSearchManager(event.target.value)
  }
  if (managerBosses) {
    try {
      managerBosses.forEach((value) => {
        dataTable.push({
          gerente: value.gerente,
          gerente_id: value.gerente_id,
          jefe: value.jefe,
          jefe_id: value.jefe_id,
          unit: value.unidad_negocio_id,
        });
      });
    } catch (err) { console.log(err) }
  }

  const filterManager = filterArray(manager, 'nombre', search)
  const filterBosses = filterArray(bosses, 'nombre', searchManager)

  if (!managerBosses || !manager || !bosses) {return <ScreenLoading2 />}

  return (
    <>
      <ManagerPage
        manager={filterManager}
        bosses={filterBosses}
        managerBosses={managerBosses}
        permisos={permisos}
        select={select}
        onCreateManager={handleCreateManager}
        hadleSearchManager={hadleSearchManager}
        handleDeleteTable={handleDeleteTableMagagers}
        handleDelete={handleDelete}
        handleUpdate={handleUpdate}
        handleCreate={handleCreate}
        handleSearch={handleSearch}
        handleSelect={handleSelect}
      />
    </>
  );
};

export default GerentesContainer;
